import Header from "./Header";
import Slider from "./Slider";
import Footer from "./Footer";
import AboutUsImage from "./AboutUsImage";
import ImageGallery from "./ImageGallery";
import RadioNews from "./RadioNews";

const HomePage = () => {
  return (
    <>
      <Header />
      <Slider />
      <AboutUsImage />
      <ImageGallery />
      <RadioNews />
      <Footer />
    </>
  );
};

export default HomePage;
